import React from "react";
import { HeadContainer } from "./styled";
import {
  Avatar,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  HStack,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { User } from "../../types";

type Props = {
  user: User | null;
  onLogout: () => void;
  onNavigateToProfile: () => void;
};

export enum MenuItemKeys {
  board,
  tasks,
  projects,
  dashboard,
  integrations,
}

export const Header: React.FC<Props> = ({
  user,
  onLogout,
  onNavigateToProfile,
}) => {
  const { t } = useTranslation();

  return (
    <HeadContainer>
      <Menu>
        <HStack>
          {user && (
            <Text>
              {user.name} {user.surname}
            </Text>
          )}
          <MenuButton px={4} py={2}>
            <Avatar
              src={user?.picture}
              values={user?.name || []}
              alt={user?.nominative}
              extendend
            />
          </MenuButton>
        </HStack>

        <MenuList>
          <MenuItem onClick={onNavigateToProfile}>{t("nav.profile")}</MenuItem>
          <MenuItem onClick={onLogout}>{t("nav.logout")}</MenuItem>
        </MenuList>
      </Menu>
    </HeadContainer>
  );
};
